import React, { useContext } from 'react';
import { DataContext } from '../Services/DataContext';
import MainLayout from '../Layouts/MainLayout';
import SideBar from '../Layouts/SideBar';
import CustomList from '../Layouts/CustomList';

function Blog() {
    const { posts } = useContext(DataContext);
    
    // Vérifier si posts existe et est un tableau, sinon utiliser un tableau vide
    const safePosts = Array.isArray(posts) ? posts : [];
    
    const barParams = { 
        nav1: 'Nom', 
        nav2: 'Categorie', 
        nav3: '', 
        nav4: '', 
        nav5: '' 
    };
    
    const titleItem = { 
        name: "Blog", 
        title1: "Nouveau Post", 
        title2: "Posts", 
        title3: "Posts", 
        title4: "Posts"
    };
    
    const linkItem = {  
        link1: "/dashboard/post/new-post", 
        link2: "#", 
        link3: "#", 
        link4: "#"
    };
    
    const linkList = { 
        show: `/dashboard/post/show-post`, 
        edit: "/dashboard/post/edit-post"
    };

    return (
        <div className='Product-layout'>
            <SideBar />
            <MainLayout 
                titleItem={titleItem}
                linkItem={linkItem}
                numberItem={safePosts.length}
            />
            <CustomList
                barParams={barParams}
                listItems={[...safePosts].reverse()}
                linkList={linkList}
                key1="name"
                key2="slug"
                key3=""
                key4=""
                key5=""
                idKey="_id"
                urlDelete="faq/categories"
            />
        </div>
    );
}

export default Blog;